<div class="snapshot-container">
  <xs-device-info-view
    [style.display]="isLicenceActive || snapshotActivity?.activityId > 0 ? null : 'none'"
    [style.max-height]="isTicketPage() ? 'calc(100vh - 108px)' : null"
    [titleHeight]="titleHeight"
    [device]="device"
    [activityId]="snapshotActivity?.activityId"
    [isLive]="isLive"
    (snapshotRefreshInProgress)="onSnapshotRefreshInProgressChanged($event)"
    (setToast)="setToast.emit($event)"
  >
  </xs-device-info-view>
  <xs-device-info
    [device]="device"
    [style.display]="isLicenceActive || snapshotActivity?.activityId > 0 ? 'none' : null"
    (setToast)="setToast.emit($event)"
  ></xs-device-info>
  <ng-template #actionBar>
    <!--does not render here, will render in the workpanel -->
    <div class="snapshot-action-bar" [style.display]="isSnapshotBarHidden ? 'none' : null">
      <xs-snapshot-buttons
        [device]="device"
        [isLicenseActive]="isLicenceActive"
        [disableRefresh]="isSnapshotRefreshInProgress"
        [isSaveSnapshotEnabled]="isSaveSnapshotEnabled"
        (refreshPressed)="refreshClicked()"
        (isAnyButton)="setSnapshotBarVisible($event)"
        (setToast)="setToast.emit($event)"
      >
      </xs-snapshot-buttons>
    </div>
  </ng-template>
</div>

<ng-template #titleBar>
  <!--does not render here, will render in the workpanel -->
  <xs-snapshot-title-bar
    [device]="device"
    [isLicenceActive]="isLicenceActive || snapshotActivity?.activityId > 0"
    [mcName]="mcConnectionName"
    [isPopInOutDisabled]="isPopInOutDisabled"
    [isMinimizeButtonVisible]="isMinimizeButtonVisible"
    [date]="getCreationDate()"
    [isLiveSnapshot]="isLive"
    [isSnapshotRefreshInProgress]="isSnapshotRefreshInProgress"
    (closeSnapshotEvent)="closeSnapshot()"
    [popOut]="popOut"
    (minimizeSnapshotEvent)="minimizeSnapshot()"
  >
  </xs-snapshot-title-bar>
</ng-template>
